module.exports = __webpack_public_path__ + "img/icon-arrow-right-green.7bcac5c5.svg";